import * as React from "react";
import MailinglistList from "src/components/MailinglistList";
import MailingListsQuery from "src/queries/MailingListsQuery";
export default () => (
  <MailingListsQuery>
    {({ loading, error, data }) => {
      if (!data) {
        return null;
      }
      if (error) {
        return <h1>ERROR</h1>;
      }
      return (
        <MailinglistList mailinglists={data.mailingLists} loading={loading} />
      );
    }}
  </MailingListsQuery>
);



// WEBPACK FOOTER //
// ./src/screens/MailingLists/MailingListsPage.tsx